import { completed } from '#components/generics/js/completion/list/list.js'
import { list } from '#components/generics/js/xaddrs/list.js'
import { elements, modifiers } from '#components/generics/js/xaddrs/styles.js'
import globals from '#utilities/js/ea/globals.js'
import * as utilities from '#utilities/js/styles.js'
import { render } from '#utilities/js/template/template.js'
import preventDefault
  from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import blur from '@mailobj-browser/front/js/events/types/blur.js'
import focusIn from '@mailobj-browser/front/js/events/types/focusIn.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import mouseOut from '@mailobj-browser/front/js/events/types/mouseOut.js'
import mouseOver from '@mailobj-browser/front/js/events/types/mouseOver.js'
import mouseUp from '@mailobj-browser/front/js/events/types/mouseUp.js'
import paste from '@mailobj-browser/front/js/events/types/paste.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const keys = object(null, {
  async Enter (
    input,
    event
  ) {
    if (event) {
      preventDefault(event)
    }

    input.blur()
  }
})

const onKeyDown = object(listener, {
  type: keyDown,
  task: async (
    input,
    event
  ) => {
    const { defaultPrevented, key } = event

    if (defaultPrevented) {
      return
    }

    await keys[key]?.(input, event)
  }
})

// @todo : à quoi ça sert
const onFocusIn = object(listener, {
  type: focusIn,
  passive,
  task: async (
    input
  ) => {
    try {
      const promise = completed()

      if (promises.has(promise)) {
        return
      }

      promises.add(promise)

      if (await promise) {
        await validate(input)
        promises.delete(promise)
      }
    } catch {}
  }
})

const onBlur = object(listener, {
  type: blur,
  passive,
  task: async (
    input
  ) => {
    try {
      await completed()
    } catch {}

    await validate(input, false)
  }
})

const validate = async (
  input,
  focus = true,
  value = input.value
) => {
  const completion = list(input)

  if (!completion || !value.trim()) {
    return
  }

  const { loading } = completion
  const li = closest('li', input)
  const template = one('template[data-url*="req_xaddrs"]', li)

  const emails = value.replace(/ <[^@>]+>[^;,]+/g, '')
  li.classList.add(modifiers.item.loading)
  loading.classList.remove(utilities.modifiers.display.none)
  await render(template, false, { emails })
  loading.classList.add(utilities.modifiers.display.none)
  li.classList.remove(modifiers.item.loading)
}

const onPaste = object(listener, {
  type: paste,
  hooks: array([
    preventDefault
  ]),
  task: async (
    input,
    event
  ) => {
    const { clipboardData } = event
    const value = normalize(merge(input, clipboardData))

    input.value = value

    if (value !== '') {
      await validate(input, true)
    }
  }
})

const onInput = object(listener, {
  type: input,
  passive,
  task: async (
    input
  ) => {
    const lastChar = input.value.at(-1)

    if (lastChar === ',' || lastChar === ';') {
      await validate(input, true)
    }
  }
})

const trim = str => str.trim()

const normalize = (
  data
) => {
  return data
    .split(/[\r\n,;]/)
    .map(trim)
    .filter(Boolean)
    .join('; ')
}

const merge = (
  input,
  dataTransfer = null
) => {
  const { selectionStart, selectionEnd, value } = input

  if (!dataTransfer) {
    return value
  }

  const { types } = dataTransfer
  const [type] = types
  const [...chars] = value
  
  if (type === 'text/html') {
    const { ownerDocument } = input
    const { defaultView } = ownerDocument
    const { DOMParser } = defaultView
    const data = dataTransfer.getData(type)
    const parsedDoc = new DOMParser().parseFromString(data, 'text/html')
    const textContent = parsedDoc.body.textContent || ''

    chars.splice(selectionStart, selectionEnd - 1, ...textContent)
  }

  if (type === 'text/plain') {
    const data = dataTransfer.getData(type)

    chars.splice(selectionStart, selectionEnd - 1, ...data)
  }

  return chars.join('')
}

const onMouseOver = object(listener, {
  type: mouseOver,
  passive,
  task: async (
    li
  ) => {
    const { ea_mouse_obj } = globalThis

    if (!ea_mouse_obj) {
      return
    }

    globals.ea_mouse_drag_test('email')
  }
})

const onMouseOut = object(listener, {
  type: mouseOut,
  passive,
  task: async (
    li
  ) => {
    const { ea_mouse_obj } = globalThis

    if (!ea_mouse_obj) {
      return
    }

    globals.ea_mouse_drag_test('')
  }
})

const onMouseUp = object(listener, {
  type: mouseUp,
  passive,
  task: async (
    li
  ) => {
    const input = one(`.${elements.add_input}`, li)
    const { ea_mouse_obj } = globalThis

    if (!ea_mouse_obj) {
      return
    }

    input.value = globals.ea_mouse_drag_elts('email').join(';')
    await validate(input)
    globals.ea_mouse_drag_stop()
  }
})

export default (
  input
) => {
  const item = closest('li', input)

  onFocusIn.listen(input)
  onBlur.listen(input)
  onKeyDown.listen(input)
  onPaste.listen(input)
  onInput.listen(input)

  onMouseOut.listen(item)
  onMouseOver.listen(item)
  onMouseUp.listen(item)
}
